interface Props {
  kind: string;
}

const META: Record<string, { label: string; icon: string }> = {
  'benchmark-passed': { label: 'Benchmark Passed', icon: '🎯' },
  'dojo-mastered': { label: 'Dojo Mastery', icon: '🥋' }
};

export function Badge({ kind }: Props) {
  const m = META[kind] ?? { label: kind, icon: '⭐' };
  return (
    <span className="badge" title={m.label}>
      <span aria-hidden>{m.icon}</span> {m.label}
    </span>
  );
}
